import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const WarningIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M10.5 2.4a3 3 0 0 1 4.1 1.1l8 14A3 3 0 0 1 20 22H4a3 3 0 0 1-2.6-4.5l8-14a3 3 0 0 1 1-1.1ZM12 4a1 1 0 0 0-.9.5l-8 14A1 1 0 0 0 4 20h16a1 1 0 0 0 .9-1.5l-8-14a1 1 0 0 0-1-.5Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M12 8c.6 0 1 .4 1 1v4a1 1 0 0 1-2 0V9c0-.6.4-1 1-1Zm-1 9c0-.6.4-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default WarningIcon;
